webpackJsonp([142629428675168],{

/***/ 661:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"relativePath":"GDK>src/pages/landing.js"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-fabf0a82e327c1d00460.js